import { useCallback, useEffect, useState } from 'react';

import { FetchError } from 'exceptions/FetchError';
import { apiUrls } from 'services/api-urls';
import { fetcher } from 'services/fetcher';
import { OrderConfirmationData } from 'types/Order';

type HookReturn = {
  isLoaded: boolean;
  order?: OrderConfirmationData;
  error?: FetchError;
};

function useLastOrder(): HookReturn {
  const [isLoaded, setLoaded] = useState(false);
  const [order, setOrder] = useState<OrderConfirmationData | undefined>();
  const [error, setError] = useState<FetchError | undefined>();
  const getLatestOrder = useCallback(async () => {
    const response = await fetcher(apiUrls.getOrderConfirmation(), true);
    if (!response.ok) {
      throw new FetchError('Could not fetch order', response.status);
    }

    return await response.json();
  }, []);

  useEffect(() => {
    getLatestOrder()
      .then(res => setOrder(res))
      .catch(err => setError(err))
      .finally(() => setLoaded(true));
  }, []);

  return {
    isLoaded,
    order,
    error,
  };
}

export default useLastOrder;
